import EntityManager from "@/components/EntityManager";

export default function InstrumentTechsPage() {
  return (
    <EntityManager
      testidPrefix="it"
      title="Instrumentadores"
      description="Instrumentadores cirúrgicos. Podem ser atribuídos ao caso após a cirurgia."
      endpoint="/instrument-technicians"
      columns={[
        { key: "full_name", label: "Nome" },
        { key: "registration", label: "Registro" },
        { key: "active", label: "Ativo?", render: (s) => s.active ? "Sim" : "Não" },
      ]}
      fields={[
        { name: "full_name", label: "Nome completo", required: true, fullWidth: true },
        { name: "display_name", label: "Nome de exibição" },
        { name: "registration", label: "Registro / Identificador" },
        { name: "active", label: "Ativo", type: "checkbox", default: true, checkboxLabel: "Ativo" },
        { name: "notes", label: "Observações", type: "textarea", fullWidth: true },
      ]}
    />
  );
}
